/*
 * @Date: 2024-07-19 12:53:31
 * @LastEditors: p彭 9878922+p-pengrulin@user.noreply.gitee.com
 * @LastEditTime: 2024-09-30 10:28:54
 */
// baseUrl
export const baseUrl = process.env.VUE_APP_BASE_URL;

// 根目录的fontsize value，用于自适应屏幕，px to rem
export const rootFontSize = 37.5;

export const lark_reportwebhook =
  "https://open.larksuite.com/open-apis/bot/v2/hook/0085171a-22d5-4215-a71c-bb552b59f3d2";

export const pc_uiWidth = 1920; // pc
export const pc_uiWidth1 = 1440; // pc
export const mobile_uiWidth = 390; // mobile

const randomNumber = Math.floor(Math.random() * 6);
export const avatar = require(`@/assets/avatar/avatar${randomNumber}.svg`);
